import * as yup from 'yup';
import {
  MAX_DEFAULT_FIELD_SYMBOLS,
  MAX_DEFAULT_BIG_FIELD_SYMBOLS,
} from 'constants/general';

const customFieldOptionSchema = yup.object().shape({
  name: yup
    .string()
    .required('Option name is required')
    .max(
      MAX_DEFAULT_FIELD_SYMBOLS,
      `Option name must not exceed ${MAX_DEFAULT_FIELD_SYMBOLS} characters`
    ),
  color: yup.string().optional(),
});

const customFieldSchema = yup.object().shape({
  name: yup
    .string()
    .required('Field name is required')
    .max(
      MAX_DEFAULT_FIELD_SYMBOLS,
      `Field name must not exceed ${MAX_DEFAULT_FIELD_SYMBOLS} characters`
    ),
  type: yup.string().required('Type is required'),
  placeholder: yup
    .string()
    .max(
      MAX_DEFAULT_FIELD_SYMBOLS,
      `Placeholder must not exceed ${MAX_DEFAULT_FIELD_SYMBOLS} characters`
    ),
  maxLength: yup
    .number()
    .optional()
    .min(0, 'Max Length must be greater than or equal to 0')
    .integer('Max Length must be an integer'),
  minLength: yup
    .number()
    .optional()
    .min(0, 'Min Length must be greater than or equal to 0')
    .integer('Min Length must be an integer')
    .test(
      'min-less-than-max',
      'Min Length must be less than or equal to Max Length',
      function (value) {
        const { maxLength } = this.parent;
        if (maxLength !== undefined && value !== undefined) {
          return value <= maxLength;
        }
        return true;
      }
    ),
  options: yup.array().of(customFieldOptionSchema).optional(),
});

export const phoneCaseFormSchema = yup.object().shape({
  name: yup
    .string()
    .required('Name is required')
    .max(
      MAX_DEFAULT_FIELD_SYMBOLS,
      `Name must not exceed ${MAX_DEFAULT_FIELD_SYMBOLS} characters`
    ),
  description: yup
    .string()
    .required('Description is required')
    .max(
      MAX_DEFAULT_BIG_FIELD_SYMBOLS,
      `Description must not exceed ${MAX_DEFAULT_BIG_FIELD_SYMBOLS} characters`
    ),
  price: yup
    .number()
    .required('Price is required')
    .min(0.01, 'Price must be greater than 0')
    .typeError('Price is required')
    .test('not-zero', 'Price is required', (value) => {
      return value !== undefined && value !== null && value !== 0;
    }),
  newPrice: yup
    .number()
    .nullable()
    .min(0, 'New Price must be greater than or equal to 0')
    .typeError('New Price must be a number')
    .transform((value, originalValue) => {
      // Handle empty string or null
      if (originalValue === '' || originalValue === null) {
        return null;
      }
      return value;
    }),
  tags: yup.array().of(yup.string()).default([]),
  customFields: yup.array().of(customFieldSchema).default([]),
});
